import { ArrowRight } from "lucide-react";
import { PageHeader } from "@/components/common/PageHeader";
import { SectionHeading } from "@/components/common/SectionHeading";
import { ProcessTimeline } from "@/components/common/ProcessTimeline";
import { Reveal } from "@/components/common/Reveal";
import { FButton } from "@/components/common/FButton";
import { CTASection } from "@/components/common/CTASection";
import { StatusBadge } from "@/components/common/StatusBadge";
import { JOURNEY } from "@/data/content";

export default function HowItWorks() {
  return (
    <div data-testid="how-it-works-page">
      <PageHeader
        overline="How FanFuel Works"
        titleLines={["A clear path from", "apply to payout."]}
        lead="Eight steps, no surprises. AI helps you move faster; humans guard every money decision along the way."
        testid="how-header"
      >
        <div className="flex flex-wrap gap-2.5">
          <StatusBadge tone="ember">AI-assisted</StatusBadge>
          <StatusBadge tone="positive">Human-reviewed</StatusBadge>
          <StatusBadge tone="neutral">No passwords</StatusBadge>
        </div>
      </PageHeader>

      <section className="px-5 py-14 md:px-8 md:py-20">
        <div className="mx-auto max-w-7xl">
          <SectionHeading
            overline="The journey"
            title="Follow the fuel pathway."
            body="Each milestone moves you forward. You stay in control of your content and decisions the whole way."
          />
          <div className="mt-16">
            <ProcessTimeline steps={JOURNEY} highlightIndex={6} testid="how-timeline" />
          </div>
        </div>
      </section>

      <section className="px-5 pb-10 md:px-8">
        <Reveal className="mx-auto max-w-4xl rounded-3xl border border-ff-amber/25 bg-ff-amber/[0.06] p-8 md:p-10">
          <h3 className="font-display text-xl font-semibold text-ff-ivory md:text-2xl">
            Humans guard the money.
          </h3>
          <p className="mt-3 text-base leading-relaxed text-ff-grey">
            AI may summarize, parse, flag and calculate. It never approves, denies, marks paid or moves
            funds on its own. A real person reviews every cashout and makes the decision.
          </p>
          <div className="mt-6">
            <FButton variant="secondary" to="/cashouts" data-testid="how-cashouts-btn">
              See how cashouts work <ArrowRight className="h-4 w-4" />
            </FButton>
          </div>
        </Reveal>
      </section>

      <CTASection secondaryLabel="Read Privacy & Trust" secondaryTo="/privacy-trust" />
    </div>
  );
}
